import { createTheme } from '@mui/material/styles';

import Button from '../overrides/Button';
import TableContainer from '../overrides/TableContainer';
import TableHead from '../overrides/TableHead';
import TableCell from '../overrides/TableCell';
import Checkbox from '../overrides/Checkbox';
import Drawer from '../overrides/Drawer';
import Tabs from '../overrides/Tab';
import CircularProgress from '../overrides/CircularProgress';
import Card from '../overrides/Card';
import Tooltip from '../overrides/Tooltip';

const mode = 'light';

const theme = createTheme({
  palette: {
    mode,
    primary: {
      main: '#172664',
      mainHover: '#4B68CF',
      mainGradientPrimary: 'rgba(53, 122, 246, 0.2)',
      mainGradientSecound: 'rgba(53, 122, 246, 0.1)',
      mainGradientThird: 'rgba(53, 122, 246, 0)',
      subBlue: '#DBE0FC',
      lightBlue: '#E8EBFC',
      blueSecound: '#87A2E2',
      blueThird: '#C9DCF3',
      blueFourth: '#F2F4FF',
      blueSixth: '#22b7db',
      blackPrimary: '#23262a',
      black: '#000000',
      blackTransparency: 'rgba(0, 0, 0, 0.6)',
      greyPrimary: '#373737',
      greyPrimaryTransparency: 'rgba(55, 55, 55, 0.8)',
      greyPrimaryTransparencySecound: 'rgba(55, 55, 55, 0.3)',
      greySecound: '#5F6267',
      greyThird: '#AAAAAA',
      greyThread: '#D5D5D5',
      greyFourth: '#8E8E93',
      greyFifth: '#929292',
      greySixth: '#626262',
      greySeventh: '#969696',
      background: '#EEEEEE',
      greenPrimary: '#008514',
      greenGradientPrimary: 'rgba(199, 255, 202, 0.2)',
      greenGradientSecound: 'rgba(199, 255, 202, 0.1)',
      greenGradientThird: 'rgba(199, 255, 202, 0)',
      greenSecound: '#4BC22E',
      greenThird: '#DBE9DB',
      greenFourth: '#E8F5EA',
      greenFifth: '#009d17',
      greenSixth: '#eefef0',
      greenDark: '#16681A',
      greenLight: '#89b980',
      online: '#00B61B',
      yellowPrimary: '#F6E2A9',
      redPrimary: '#DB0046',
      subRed: '#D96B7F',
      redSecound: '#EE718A',
      redThird: '#F7D6DC',
      redFourth: '#ffeff2',
      redDark: '#AE2D45',
      redGradientPrimary: 'rgba(219, 0, 70, 0.2)',
      redGradientSecound: 'rgba(219, 0, 70, 0.1)',
      redGradientThird: 'rgba(219, 0, 70, 0)',
      purplePrimary: '#6A5FC2',
      purpleSecound: '#B594E3',
      systemBlue: '#0C8CE9',
      systemMango: '#FDAE2D',
      borderGreyPrimary: '#DDDDDD',
      white: '#FFFFFF',
      whiteSecound: '#F6F6F6',
      whiteSecoundTransparency: 'rgba(246, 246, 246, 0.6)',
      transparent: 'transparent',
      rgbTransparent: 'rgba(0, 0, 0, 0)',
      orange: '#EB982A',
      orangeSecound: '#F9F1DA',
      orangeThird: '#f59d24',
      orangeFourth: '#fff5e4',
      orangeGradientPrimary: 'rgba(245, 157, 36, 0.2)',
      orangeGradientSecound: 'rgba(245, 157, 36, 0.1)',
      orangeGradientThird: 'rgba(245, 157, 36, 0)',
    },
  },
  shape: {
    customBorderRadius: ['5px', '8px', '10px', '25px', '15px', '50%', '20px', '30px', '12px'],
    border: '1px solid'
  },
  typography: {
    fontFamily: `"Inter"`,
    customFontSize: ['12px', '13px', '14px', '15px', '16px', '20px', '35px', '40px', '25px', '10px', '18px', '22px'],
    customFontWeight: ['normal', 'bold', 500, 600],
  },
});

theme.components = {
  ...Button(theme),
  ...TableContainer(theme),
  ...TableHead(theme),
  ...TableCell(theme),
  ...Checkbox(theme),
  ...Drawer(theme),
  ...Tabs(theme),
  ...CircularProgress(theme),
  ...Card(theme),
  ...Tooltip(theme)
};

export default theme;
